// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__X96it","active":"Tile_active__u6nma"};